export default "__VITE_ASSET__CTAgNWwG__"